import { render } from "./AccountSecurity.vue?vue&type=template&id=12deaf1b"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__